import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class PeopleDataTable {
  constructor() {
    $(document).ready(function() {
      showPeopleTable();
    });

    $(document).on("turbo:render", function() {
      showPeopleTable();
    });

    function showPeopleTable() {
      $('#people-datatable').dataTable({
        "order": [[ 0, "asc" ]],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#people-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "first_name"},
          {"data": "last_name"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
